import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import PropTypes from 'prop-types';
import React from 'react';
import locale from '../locale.json';
import IconButton from '@material-ui/core/IconButton';
import Minimize from '@material-ui/icons/Remove';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import avatar from "../images/avatar.png";
import handleDescargaPDF from "./DescargarPDF"
import handleDescargaTXT from "./DescargarTxt"
import { messagesStored, getValueFromSessionStored } from '../Session';
import { saveAs } from 'file-saver';
import { pdf } from '@react-pdf/renderer';

const styles = theme => ({
  toolbarRoot: {
    display: "flex",
    minHeight: "55px",
    paddingRight: "8px",
    paddingLeft: "8px"
  },
  title: {
    fontSize: "1.92rem",
    color: theme.palette.secondary.light
  },
  avatar: {
    width: "153px",
    height: "40px",
    borderRadius: 0
  },
  header: {
    marginLeft: '0.9em',
    backgroundColor: 'inherit',
    border: 'none',
    flex: 1
  },
  chatState: {
    fontStyle: 'inherit',
    fontSize: '12px',
    color: theme.palette.secondary.light
  },
  selector: {
    color: '#FFFFFF',
    backgroundColor: 'inherit',
    flex: 0,
    '&:before': {
      borderBottom: "0px!important"
    },
    '&:after': {
      borderBottom: "0px"
    }
  },
  flag: {
    width: "25px",
    height: "auto",
    borderRadius: "0px",
    backgroundColor: 'inherit',
    marginRight: "2px"
  },
  selectedo: {
    display: "flex",
    paddingRight: "22px"
  },
  close: {
    padding: "9px",
    color: "white",
    '&:disabled':{
      color: "rgb(255, 255, 255, 0.5)"
    }
    }
})

class ChatToolbar extends React.Component {

  createItems = () => {
    let items = []
    let { classes } = this.props;
    let list_languages = this.props.languages
    let img = ""
    // Outer loop to create parent
    for (let i = 0; i < list_languages.length; i++) {
      if (locale[list_languages[i]].symbol) {
        let flag = require("../images/banderas/" + locale[list_languages[i]].symbol)
        img = <Avatar className={classes.flag} src={flag} />
      } else {
        img = ""
      }
      items.push(<MenuItem value={list_languages[i]}>{img}{list_languages[i]}</MenuItem>)
    }
    return items
  }

  handleChange = event => {
    this.props.updateLanguage(event.target.value);
  };

  getState() {
    if (this.props.is_writing) {
      if (this.props.selected_language) {
        return locale[this.props.selected_language].writing
      }
    } else {
      if (this.props.selected_language) {
        return locale[this.props.selected_language].online
      }
    }
  }

  minimize = (m) => {
    this.props.minimize();
  }

  // download = (m) => {
  //   try {
  //     handleDescargaPDF(this.props.selected_language, "", messagesStored())
  //   }
  //   catch {
  //     handleDescargaTXT(this.props.selected_language, "", messagesStored())
  //   }
  // }

  downloadPDF = async (event) => {
    let date = new Date();
    let minutes = date.getMinutes();
    let month = date.getMonth() +1;
    let days = date.getDate();
    if (minutes < 10) { minutes = "0" + minutes; }
    if (month < 10) { month = "0" + month; }
    if (days < 10) { days = "0" + days; }
    const fecha = days + "/" + month + "/" + date.getFullYear() + "  " + date.getHours() + ":" + minutes
    try {
      event.preventDefault(); // prevent page reload
      let MyDoc = handleDescargaPDF(this.props.selected_language, getValueFromSessionStored("user_id"), messagesStored(), fecha)
      const blob = await pdf(
        <MyDoc />
      ).toBlob();

      saveAs(blob, 'conversacion.pdf');
    }
    catch {
      handleDescargaTXT(this.props.selected_language, "", messagesStored(), fecha)
    }
  }

  render() {
    const { classes } = this.props;
    let selector
    if (this.props.languages.length > 1) {
      selector = <Select
        value={this.props.selected_language}
        onChange={this.handleChange}
        input={<Input name="name" />}
        className={classes.selector}
        classes={{ select: classes.selectedo }}
      >
        {this.createItems()}
      </Select>;
    } else {
      selector = "";
    }

    return (
      <AppBar className={classes.appBar} position="static">
        <Toolbar classes={{ root: classes.toolbarRoot }}>
          <Avatar className={classes.avatar} src={avatar} alt="Logo del Defensor del Pueblo" />
          <Paper className={classes.header} elevation={0}>
          </Paper>
          {selector}
          <IconButton className={classes.close} key="download" onClick={this.downloadPDF} title="Descargar conversación">
            <CloudDownloadIcon style={{ width: "25px", height: "25px" }} />
          </IconButton>
          <IconButton className={classes.close} key="close" onClick={this.minimize} title="Minimizar el asistente virtual" disabled={this.props.is_writing}>
            <Minimize style={{ width: "25px", height: "25px" }} />
          </IconButton>
        </Toolbar>
      </AppBar>
    )
  }
}


ChatToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ChatToolbar);
